module.exports = __webpack_public_path__ + "img/person-grey.d4be03ba.svg";